import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { createPortal } from 'react-dom';
import { useBreakpoint } from '~/hooks/useBreakpoint';

export type OutletSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  title?: string;
  animation?: 'slide' | 'fade';
  widthClass?: string; // CSS class to control the width of the sheet (default is set in the component)
  isStacked?: boolean;
};

const slideVariantsMobile = {
  hidden: { y: '100%', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: 'spring', stiffness: 300, damping: 30, duration: 0.35 },
  },
  exit: {
    y: '100%',
    opacity: 0,
    transition: { duration: 0.25, ease: 'easeIn' },
  },
};

const slideVariantsDesktop = {
  hidden: { x: '100%', opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 32,
      mass: 0.9,
      duration: 0.45,
    },
  },
  exit: {
    x: '100%',
    opacity: 0,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 32,
      mass: 0.9,
      duration: 0.32,
      ease: 'easeIn',
    },
  },
};

const fadeVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeOut' },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.2, ease: 'easeIn' },
  },
};

export const OutletSheet = ({
  isOpen,
  onClose,
  children,
  className,
  title,
  animation = 'slide',
  widthClass = 'w-rsb', // default width for desktop
  isStacked,
}: OutletSheetProps) => {
  const { isMobile } = useBreakpoint();
  const variants =
    animation === 'fade'
      ? fadeVariants
      : isMobile
      ? slideVariantsMobile
      : slideVariantsDesktop;

  if (isMobile) {
    const sheetContent = (
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key='outlet-sheet'
            initial='hidden'
            animate='visible'
            exit='exit'
            variants={variants}
            className={classNames(
              'fixed inset-0 flex h-screen w-screen items-end justify-center',
              isStacked ? 'z-[2000]' : 'z-[1000]',
              className
            )}
          >
            <div className='relative flex h-full w-full flex-col bg-white'>
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
    return createPortal(sheetContent, document.body);
  }

  // Desktop: Rollout later
  return (
    <>{children}</>
    /*  <AnimatePresence>
      {isOpen && (
        <motion.div
          key='outlet-sheet'
          initial='hidden'
          animate='visible'
          exit='exit'
          variants={variants}
          className={classNames(
            'relative z-[1000] flex h-full flex-col border-l border-outline-bright bg-white',
            widthClass,
            className
          )}
          style={{ minWidth: 0 }}
        >
          <div className='flex items-center justify-between border-b p-4'>
            <span className='truncate text-lg font-medium'>{title}</span>
            <IconButton
              type='close'
              onClick={onClose}
              ariaLabel='Close popup'
            />
          </div>
          <div className='flex-1 overflow-y-auto'>{children}</div>
        </motion.div>
      )}
    </AnimatePresence> */
  );
};
